export const MOCK_USERS = [
  {
    name: 'Jennifer Smith',
    designation: 'Head of sales',
    email: 'jsmith@companya.com',
  },
  {
    name: 'Perter Huntington',
    designation: 'Marketing Director',
    email: 'phuntington@companya.com',
  },
];

export const DEFAULT_ALLOWED_USERS = 5;
export const calculateMaxAllowedUsers = function() {
  const env_var_value_max_allowed_users = process.env.REACT_APP_MAX_ALLOWED_USERS;
  let maxAllowedUsers = DEFAULT_ALLOWED_USERS;
  if (env_var_value_max_allowed_users) {
    maxAllowedUsers =  parseInt(env_var_value_max_allowed_users,0);
  }
  return maxAllowedUsers;
};
export const MAXIMUM_ACCOUNTS_NUMBER = calculateMaxAllowedUsers();


const ONE_HOUR_IN_SECONDS = 60 * 60;
const ONE_DAY_IN_SECONDS = 24 * ONE_HOUR_IN_SECONDS;
const ONE_MONTH_IN_SECONDS = 30 * ONE_DAY_IN_SECONDS;
export const TIME_TO_TRIAL_IN_SECONDS = ONE_MONTH_IN_SECONDS - 1;

export const ADD_NEW_ACCOUNT_ACTION_TYPE = 'add';
export const EDIT_ACCOUNT_ACTION_TYPE = 'edit';

export const NAME        = 'name';
export const EMAIL       = 'email';
export const PASSWORD    = 'password';
export const DESIGNATION = 'designation';


// WEBPACK FOOTER //
// ./src/features/user-management/constants/UserManagementConstants.js